module.exports = __webpack_public_path__ + "img/img16.b7d577d4.png";